/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Beside_AInputs */



/**
* | output |
* | --- |
* | "Yes. Nothing is announced and no role moves until you switch, so members can try Colossus first." |
*
* @param {Products_Leveling_Faq_Beside_AInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_beside_a = /** @type {((inputs?: Products_Leveling_Faq_Beside_AInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Beside_AInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да. Пока вы не переключитесь, Colossus ничего не объявляет и не трогает роли, так что участники могут сначала его попробовать.")
	return /** @type {LocalizedString} */ ("Yes. Nothing is announced and no role moves until you switch, so members can try Colossus first.")
});